import React from 'react';
import { Skeleton } from '~/lib/bn-material-ui';

export function BnLoadingSkeleton({ loading, children }) {
  if (!loading) {
    return children;
  }

  return <Skeleton>{children}</Skeleton>;
}
